/***
 * Created on 2023/7/20
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/


import React from 'react';
import ActivityRecord from "./activity_record";

function ActivityGroup({group, data}) {
    return (
        <div className="activity-group">
            <div className="activity--date font-medium">{group}</div>
            {
                data && data.map(rec => <ActivityRecord data={rec} key={rec.user_activity_id}/>)
            }
        </div>
    );
}

export default ActivityGroup;